<style scoped lang="css">
    #chat {
        border: 1px solid gray;
        content: "";
        z-index: 0;
        background-color: white;
        border-radius: 10px;
        box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.5);
        position: relative;
        padding-top: 20px;
        height: 650px;
    }

    .chat_content {
        text-align: left;
        font-size: 12px;
        height: 500px;
        overflow: auto;
    }

    .action {
        position: absolute;
        bottom: 0px;
        padding: 0px 10px;
    }

    .chatitem {
        margin: 5px;
    }

    .name {
        display: inline-block;
        background-color: rebeccapurple;
        color: white;
        padding: 5px;
        border-radius: 10px;
        font-weight: bold;
    }

    .mychat {
        text-align: right;
    }

    .mychat .name {
        background-color: #3b5998;
    }

    .mychat .content {
        background-color: cornflowerblue;
    }

    .content {
        display: inline-block;
        border: 1px solid gray;
        border-radius: 10px;
        padding: 5px;
        margin-left: 5px;
        margin-right: 5px;
        word-break: break-word;
        max-width: 70%;
        background-color: #9c27b0;
        color: white
    }
</style>
<template>
    <v-app style="background-color: #3b5998">
        <v-content>
            <v-container fill-height>
                <v-layout align-center justify-center>
                    <v-flex xs12 sm6 md6 lg5 xl5 style="text-align: center;">
                        <img src="/img/dino.png"/>
                        <div id="chat">
                            <div class="chat_content" id="chat_content">
                                <template v-for="item in lstChat">
                                    <div class="chatitem" v-if="item.username != username">
                                        <div class="name">{{item.username}}</div>
                                        <audio controls v-if="item.type =='audio'" :src="item.src"></audio>
                                        <div class="content" v-html="item.content"></div>
                                    </div>
                                    <div v-else class="chatitem mychat">
                                        <div class="content" v-html="item.content"></div>
                                        <audio controls v-if="item.type =='audio'" :src="item.src"></audio>
                                        <div class="name">{{item.username}}</div>
                                    </div>
                                </template>
                            </div>
                            <v-layout class="action">
                                <v-btn icon @click="audioProcess">
                                    <v-icon :color="recordColor">mdi-microphone</v-icon>
                                </v-btn>
                                <v-text-field v-validate="'required'"
                                              name="content"
                                              key="content"
                                              v-model="content"
                                              autofocus
                                              ref="content"
                                              append-icon="send"
                                              :data-vv-as="$t('lang.user.username')"
                                              :error-messages="errors.first('login')"
                                              @keydown.enter="sendText"
                                              @click:append="sendText"
                                />
                            </v-layout>
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
    import LangSwitcher from "../../components/header/LangSwitcher";
    import {message} from '../../services';
    import axios from "axios";
    import {Validator} from "vee-validate";

    export default {
        components: {
            LangSwitcher
        },
        data() {
            return {
                user: null,
                recording: false,
                username: 'You',
                chatBotSession: null,
                lstChat: [],
                content: "",
                mediaRecorder: null,
                mediaData: [],
            }
            0
        },

        computed: {
            recordColor() {
                if (this.recording) {
                    return "blue";
                } else {
                    return "black";
                }
            }
        },

        beforeCreate() {
        },

        beforeRouteUpdate() {
            //console.log("route updated");
        },

        created() {
            this.initChatBot();
            this.initRecording();
            /*
                        this.lstChat = [
                            {"username": 'Havm', time: new Date(), content: 'Xin chào các bạn của tôi'},
                            {"username": 'Sealight803', time: new Date(), content: 'Xin chào các bạn của tôi'},
                            {"username": 'Nguyetdtm85', time: new Date(), content: 'Xin chào các bạn của tôi'},
                            {
                                "username": 'Havm',
                                time: new Date(),
                                content: 'Xin chào các bạn của tôi Xin chào các bạn của tôi Xin chào các bạn của tôi Xin chào các bạn của tôi Xin chào các bạn của tôi'
                            },
                            {"username": 'Havm', time: new Date(), content: 'Xin chào các bạn của tôi'},
                            {"username": 'Havm', time: new Date(), content: 'Xin chào các bạn của tôi'},
                        ]
            */
        },

        mounted() {
        },

        methods: {

            sendText() {
                let item = {
                    username: this.username,
                    type: 'text',
                    content: this.content,
                    date: new Date()
                }
                this.lstChat.push(item);
                let chatContext = {
                    "actionType": "INPUT",
                    "data": {
                        "id": 'user-message' + '-' + Date.now() + '-' + Math.random(0, 100000000),
                        "type": "UserText",
                        "content": {
                            "text": this.content
                        }
                    }
                }
                this.content = "";
                axios.post("https://bot.xbot.vn/chatbot/chat/" + this.chatBotSession, chatContext).then(
                    data => {
                        for (let i = 0; i < data.data.length; i++) {
                            let item = {
                                username: "PJICO",
                                content: data.data[i].message.content.text,
                                date: new Date()
                            };
                            this.lstChat.push(item);
                            this.chatToText(item.content);
                        }
                        this.$nextTick(
                            () => {
                                let chat = document.getElementById("chat_content");
                                chat.scrollTop = chat.scrollHeight;
                            }
                        )
                    }
                );
            },

            initChatBot() {
                axios.get("https://bot.xbot.vn/chatbot/0c4ff4de-9172-4cb9-9583-689abb6ffe24").then(
                    data => {
                        this.chatBotSession = data.data.context.sessionId;
                    }
                );
            },

            initRecording() {
                if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                    //console.log('getUserMedia supported.');
                    navigator.mediaDevices.getUserMedia({audio: true})
                        .then(stream => {
                            this.mediaRecorder = new MediaRecorder(stream);
                            this.mediaRecorder.ondataavailable = e => {
                                console.log(e);
                                this.mediaData.push(e.data);
                                if (this.mediaRecorder.state == 'inactive') {
                                    this.newAudioChat();
                                }
                                ;
                            };
                        })

                        // Error callback
                        .catch(function (err) {
                                console.log('The following getUserMedia error occurred: ' + err);
                            }
                        );
                } else {
                    console.log('getUserMedia not supported on your browser!');
                }

            },

            newAudioChat() {
                let blob = new Blob(this.mediaData, {type: "audio/wav"})
                    , url = URL.createObjectURL(blob);

                let item = {
                    username: this.username,
                    type: 'audio',
                    content: this.content,
                    src: url,
                    date: new Date()
                }
                this.lstChat.push(item);
                let audio = {
                    file: blob,
                    key: 'api-bd69d629-473a-4706-9b73-e43e90fcfac8'
                }
                const formData = new FormData()
                formData.append('file', blob, 'content');
                formData.append('key', 'api-bd69d629-473a-4706-9b73-e43e90fcfac8');

                axios.post("http://stt.dinosoft.vn/api/v1/speechtotextapi/post-and-decode-file", formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },

                }).then(
                    data => {
                        console.log(data);
                    }
                )
            },

            chatToText(text){
                let param = {
                    "text": text,
                    "voice": "doanngocle",
                    "id": "2",
                    "without_filter": false,
                    "speed": 1.0,
                    "tts_return_option": 2

                }

                axios.post("https://viettelgroup.ai/voice/api/tts/v1/rest/syn",param,{
                    headers: {
                        'Content-Type': 'application/json',
                        'token': 'PfVgD7TvTGFBYGfuUA9bnnWqkClxi7CVSuRgt2aS-juDOpQ88fiMYaa87IlNlRk3'
                    },
                    responseType: 'blob'

                }).then(
                    data=>{

                        const url = window.URL.createObjectURL(new Blob([data]));

/*
                        let utf8Encode = new TextEncoder();
                        let raw = utf8Encode.encode(data);
                        let blob = new Blob(raw, {type: "audio/wav"})
                            , url = URL.createObjectURL(blob);
*/
                        let item = {
                            username: "PJICO",
                            type: 'audio',
                            content: "",
                            src: url,
                            date: new Date()
                        }
                        this.lstChat.push(item);
                    }
                )

            },

            startRecording() {
                this.mediaData = [];

                this.mediaRecorder.start();

            },

            stopRecording() {
                console.log(this.mediaData);
                this.mediaRecorder.stop();
            },

            audioProcess() {
                this.recording = !this.recording;
                if (this.recording) {
                    //
                    // start recording
                    //
                    this.startRecording();
                } else {
                    //
                    // send data
                    //
                    this.stopRecording();
                }
            },
        }
    };
</script>

